import { db } from './config';
import { collection, getDocs, doc, updateDoc, deleteDoc, query, orderBy, getDoc, addDoc } from 'firebase/firestore';

const COLLECTION_NAME = 'treatments';

// Get all treatments
export const getTreatments = async () => {
  try {
    const treatmentsCollection = collection(db, COLLECTION_NAME);
    const treatmentsQuery = query(treatmentsCollection, orderBy('name'));
    const querySnapshot = await getDocs(treatmentsQuery);
    
    const treatments = [];
    querySnapshot.forEach((doc) => {
      treatments.push({ id: doc.id, ...doc.data() });
    });
    
    return treatments;
  } catch (error) {
    console.error('Error retrieving treatments:', error);
    return [];
  }
};

// Get active treatments (for client-facing pages)
export const getActiveTreatments = async () => {
  try {
    const treatmentsCollection = collection(db, COLLECTION_NAME);
    
    // Simplified query - just get all treatments and filter in JavaScript
    const treatmentsQuery = query(treatmentsCollection);
    
    const querySnapshot = await getDocs(treatmentsQuery);
    
    const treatments = [];
    querySnapshot.forEach((doc) => {
      const treatmentData = doc.data();
      
      // Only include active treatments
      if (treatmentData.active === true) {
        treatments.push({ id: doc.id, ...treatmentData });
      }
    });
    
    // Sort by name
    treatments.sort((a, b) => a.name.localeCompare(b.name));
    
    return treatments;
  } catch (error) {
    console.error('Error retrieving active treatments:', error);
    return [];
  }
};

// Get a single treatment by ID
export const getTreatmentById = async (id) => {
  try {
    const treatmentRef = doc(db, COLLECTION_NAME, id);
    const treatmentSnap = await getDoc(treatmentRef);
    
    if (treatmentSnap.exists()) {
      return { id: treatmentSnap.id, ...treatmentSnap.data() };
    }
    return null;
  } catch (error) {
    console.error('Error retrieving treatment:', error);
    return null;
  }
};

// Add a new treatment
export const addTreatment = async (treatmentData) => {
  try {
    const dataToAdd = {
      ...treatmentData,
      active: treatmentData.active !== undefined ? treatmentData.active : true,
      createdAt: new Date().toISOString(),
    };

    const docRef = await addDoc(collection(db, COLLECTION_NAME), dataToAdd);
    return { id: docRef.id, ...dataToAdd };
  } catch (error) {
    console.error('Error adding treatment:', error);
    throw error;
  }
};

// Update a treatment
export const updateTreatment = async (id, treatmentData) => {
  try {
    const treatmentRef = doc(db, COLLECTION_NAME, id);
    const updatedData = {
      ...treatmentData,
      updatedAt: new Date().toISOString()
    };
    
    await updateDoc(treatmentRef, updatedData);
    
    // Return the updated treatment
    const updatedTreatmentSnap = await getDoc(treatmentRef);
    return { id, ...updatedTreatmentSnap.data() };
  } catch (error) {
    console.error('Error updating treatment:', error);
    throw error;
  }
};

// Delete a treatment
export const deleteTreatment = async (id) => {
  try {
    const treatmentRef = doc(db, COLLECTION_NAME, id);
    await deleteDoc(treatmentRef);
    return id;
  } catch (error) {
    console.error('Error deleting treatment:', error);
    throw error;
  }
};